import React, { Component } from "react";
import "./styles.css";
import MicRecorder from "mic-recorder-to-mp3";
import S3FileUpload from "../../utilities/react-s3/src/ReactS3.js";
import { uploadFile } from "../../utilities/react-s3/src/ReactS3.js";
import { save } from "save-file";
import randomstring from "randomstring";

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const config = {
  bucketName: "thrive-web-app",
  dirName: "uploads" /* optional */,
  region: "eu-central-1",
  accessKeyId: "AKIAI4LARSLTVPRMDDDQ",
  secretAccessKey: "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"
};

class AudioRecorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRecording: false,
      isBlocked: false,
      blobURL: "",
      audioFile: null
    };
    this.handleUpload = this.handleUpload.bind(this);
  }

  start = () => {
    if (this.state.isBlocked) {
      return;
    } else {
      Mp3Recorder.start()
        .then(() => {
          this.setState({ isRecording: true });
        })
        .catch(e => console.error(e));
    }
  };

  stop = () => {
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = URL.createObjectURL(blob);
        this.setState({ isRecording: false }, () => {
          this.handleUpload(blobURL);
        });
      })
      .catch(e => console.log(e));
  };

  handleUpload(blobURL) {
    const randomName = randomstring.generate() + ".mp3";
    fetch(blobURL)
      .then(res => res.blob()) // Gets the response and returns it as a blob
      .then(blob => {
        blob.name = randomName;
        uploadFile(blob, config).then(res => {
          const prevAudioFiles =
            this.props.answer && this.props.answer.audioFiles
              ? this.props.answer.audioFiles
              : [];
          this.props.setAnswer({
            answer: {
              ...this.props.answer,
              audioFiles: [
                ...prevAudioFiles,
                { ...res, id: randomstring.generate() }
              ]
            }
          });
        });
      });
  }

  componentDidMount() {
    if (!navigator.mediaDevices) {
      alert("Secure connection is required in order to use the microphone");
      return;
    }
    navigator.mediaDevices.getUserMedia(
      { audio: true },
      () => {
        this.setState({ isBlocked: false });
      },
      () => {
        this.setState({ isBlocked: true });
      }
    );
  }

  render() {
    return (
      <div className="audio-recorder">
        <div className="audioBttns">
          <div
            className={
              this.state.isRecording
                ? "bttn-microphone bttn-is-disabled"
                : "bttn-microphone bttn-is-enabled"
            }
          >
            <div
              onClick={this.start}
              disabled={this.state.isRecording}
              className="button"
            >
              <i className="icon-microphone-full" />
            </div>
          </div>
          <div
            className={
              this.state.isRecording
                ? "bttn-microphone-stop bttn-is-enabled"
                : "bttn-microphone-stop bttn-is-disabled"
            }
          >
            <button onClick={this.stop} disabled={!this.state.isRecording}>
              <div className="blink">&#9632;</div>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default AudioRecorder;



// WEBPACK FOOTER //
// ./src/components/AudioRecorder/AudioRecorder.js